/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/ua/sd_applications
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postSdApplicationsUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/sd_applications`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewUAIntakeApplicationIdentifierResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

export { postSdApplicationsUtil };
